const AUTH_STORAGE_KEY = 'mindvrik_auth_user';
const AUTH_TOKEN_KEY = 'mindvrik_auth_token';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api';

const readJson = (key, fallback) => {
  try {
    const stored = window.localStorage.getItem(key);
    return stored ? JSON.parse(stored) : fallback;
  } catch (error) {
    return fallback;
  }
};

const writeJson = (key, value) => {
  window.localStorage.setItem(key, JSON.stringify(value));
};

const getToken = () => window.localStorage.getItem(AUTH_TOKEN_KEY);

const request = async (path, options = {}) => {
  const token = getToken();
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });

  let payload = null;
  try {
    payload = await response.json();
  } catch (error) {
    payload = null;
  }

  if (!response.ok) {
    throw new Error(payload?.detail || payload?.message || 'Request failed. Please try again.');
  }

  return payload;
};

const saveSession = ({ token, user }) => {
  window.localStorage.setItem(AUTH_TOKEN_KEY, token);
  writeJson(AUTH_STORAGE_KEY, user);
  return user;
};

export const authService = {
  async signup(payload) {
    const result = await request('/auth/signup', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return saveSession(result);
  },

  async login({ email, password, role }) {
    const result = await request('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password, role }),
    });
    return saveSession(result);
  },

  async forgotPassword(email) {
    if (!email) throw new Error('Email is required.');
    return request('/auth/forgot-password', {
      method: 'POST',
      body: JSON.stringify({ email }),
    });
  },

  async resetPassword({ token, password }) {
    if (!token) throw new Error('Reset token is missing.');
    if (!password || password.length < 6) throw new Error('Password must be at least 6 characters.');
    return request('/auth/reset-password', {
      method: 'POST',
      body: JSON.stringify({ token, password }),
    });
  },

  async refreshCurrentUser() {
    const token = getToken();
    if (!token) return null;
    const user = await request('/auth/me');
    writeJson(AUTH_STORAGE_KEY, user);
    return user;
  },

  async getRegisteredMembers() {
    return request('/admin/users');
  },

  getCurrentUser() {
    return readJson(AUTH_STORAGE_KEY, null);
  },

  logout() {
    window.localStorage.removeItem(AUTH_STORAGE_KEY);
    window.localStorage.removeItem(AUTH_TOKEN_KEY);
  },
};
